module.exports = (__webpack_require__(93083))(22);